/* import __COLOCATED_TEMPLATE__ from './admin-message-component.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import ConversationPartComponentBase from 'embercom/components/conversation/stream/conversation-part-component-base';
import DefaultAvatars from '@intercom/pulse/lib/default-avatars';

export default class AdminMessageComponent extends ConversationPartComponentBase {
  get defaultAdminAvatar() {
    return DefaultAvatars.admins[128];
  }
}
